var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'row ' + _vm.className + ' ' + _vm.listLayoutClass,attrs:{"id":_vm.idName}},[_vm._l((_vm.dataList),function(item){return _vm._t("default",null,{"data":item})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }